<template>
  <div class="quicksearch">
    <div class="wrap">
      <XDropdown ref="typeSelect" @change="selectQueryType">
        <span>{{$t('query.type.rate_short')}}</span>
        <XDropdownMenu slot="list">
          <XDropdownItem _id="rate">税率</XDropdownItem>
          <XDropdownItem _id="hscode">商品税则</XDropdownItem>
          <XDropdownItem _id="rules">原产地规则</XDropdownItem>
          <XDropdownItem _id="rulesdecide">原产地判定</XDropdownItem>
          <XDropdownItem _id="enjoy">享惠分析</XDropdownItem>
        </XDropdownMenu>
      </XDropdown>
      <div class="inputs clearfix" @keyup="escEvent">
        <Export class="ex" ref="ex" :width="'200%'" :currentState="currentState" @handleClick="handleClick" @closeDropdown="closeDropdown"></Export>
        <Import class="im" ref="im" :width="'200%'" :currentState="currentState" @handleClick="handleClick" @closeDropdown="closeDropdown"></Import>
        <Product      placeholderText="商品编码/商品名称"  class="pr" ref="pr" :currentState="currentState" @handleClick="handleClick" @closeDropdown="closeDropdown"></Product>
      </div>
      <div class="btn thm-btn" @click.prevent="searchHandle"><span>{{$t('btn.search')}}</span></div>
    </div>
  </div>
</template>

<script>
import Velocity from 'velocity-animate'
import Export from '../common/Export'
import Import from '../common/Import'
import Product from '../common/Product'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapSearchState, mapMutations: mapSearchMutations } = createNamespacedHelpers('search')
const { mapState: mapDataState, mapGetters: mapDataGetters } = createNamespacedHelpers('data')

export default {
  name: 'QuickSearch',
  data () {
    return {
      searchDoing: false,
      isShowSearchMsg: true
    }
  },
  components: { Import, Export, Product },
  watch: {
    currentState (newVal, oldVal) {
      setTimeout(() => {
        this.valueSync()
      }, 50)
    }
  },
  computed: {
    currentState: {
      get () {
        return this.getActiveName()
      },
      set (v) {
        this.updateState(v)
      }
    },
    apiPrice () {
      if (this._.isEmpty(this.apiValue)) {
        return null
      } else {
        return this.getApiValue()
      }
    },
    ...mapDataState({
      apiValue: state => state.apiValue,
      importerAll: state => state.importerAll
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.valueSync()
    })
  },
  methods: {
    valueSync () {
      this.$refs.typeSelect.selectOption(this.currentState, `[_id="${this.currentState}"]`)
      this.$refs.ex.$el.style.display = 'block'
      this.$refs.im.$el.style.display = 'block'
      this.$refs.ex.$el.style.width = '1%'
      this.$refs.ex.$el.style.opacity = 0
      this.$refs.im.$el.style.width = '1%'
      this.$refs.im.$el.style.opacity = 0
      this.$refs.pr.$el.style.width = '1%'
      this.$refs.pr.$el.style.opacity = 0
      this.tabChangeSetValue()
      switch (this.currentState) {
        case 'rate':
        case 'rules':
        case 'rulesdecide':
        case 'enjoy':
          Velocity(this.$refs.ex.$el, { width: '29%', opacity: 1 }, { duration: 250 })
          Velocity(this.$refs.im.$el, { width: '29%', opacity: 1 }, { duration: 250, delay: 50 })
          Velocity(this.$refs.pr.$el, { width: '42%', opacity: 1 }, { duration: 250, delay: 50 })
          break
        case 'hscode':
          if (this.importerAll.length > 1) {
            setTimeout(() => {
              if (this.$refs.ex) {
                this.$refs.ex.$el.style.display = 'none'
              }
            }, 100)
            Velocity(this.$refs.im.$el, { width: '29%', opacity: 1 }, { duration: 250, delay: 50 })
            Velocity(this.$refs.pr.$el, { width: '71%', opacity: 1 }, { duration: 250, delay: 100 })
          } else {
            setTimeout(() => {
              if (this.$refs.ex) {
                this.$refs.ex.$el.style.display = 'none'
              }
              if (this.$refs.im) {
                this.$refs.im.$el.style.display = 'none'
              }
            }, 100)
            Velocity(this.$refs.pr.$el, { width: '100%', opacity: 1 }, { duration: 500, delay: 50 })
          }
          break
      }
    },
    searchByHS (hasDropdown = false) {
      this.searchDoing = false
      if (this.importerAll.length > 1) {
        if (this.$refs.im.text && !this.$refs.im.value.id) {
          if (!hasDropdown && this.isShowSearchMsg) {
            this.$Message.warning({content: this.$t('query.message.import_error'), closable: true})
          }
          this.isShowSearchMsg = true
          return
        }
      }
      if (this.$refs.pr.text && !this.$refs.pr.value.id) {
        if (!hasDropdown && this.isShowSearchMsg) {
          this.$Message.warning({content: this.$t('query.message.product_error'), closable: true})
        }
        this.isShowSearchMsg = true
      } else {
        this.jfNotice()
      }
    },
    searchByOther (hasDropdown = false) {
      this.searchDoing = false
      if (this.$refs.ex.text && !this.$refs.ex.value.id) {
        if (!hasDropdown && this.isShowSearchMsg) {
          this.$Message.warning({content: this.$t('query.message.export_error'), closable: true})
        }
        this.isShowSearchMsg = true
        return
      }
      if (this.$refs.im.text && !this.$refs.im.value.id) {
        if (!hasDropdown && this.isShowSearchMsg) {
          this.$Message.warning({content: this.$t('query.message.import_error'), closable: true})
        }
        this.isShowSearchMsg = true
        return
      }
      if (this.$refs.pr.text && !this.$refs.pr.value.id) {
        if (!hasDropdown && this.isShowSearchMsg) {
          this.$Message.warning({content: this.$t('query.message.product_error'), closable: true})
        }
        this.isShowSearchMsg = true
        return
      }
      this.jfNotice()
    },
    searchHandle () {
      if (this.searchDoing) return
      if (['rulesdecide', 'enjoy'].indexOf(this.currentState) != -1) {
        this.$Message.info({content: '即将上线，敬请期待', duration: 1})
        return
      }
      this.searchDoing = true
      if (this.currentState === 'hscode') {
        if (!this.$refs.pr || (this.importerAll.length > 1 && !this.$refs.im)) return
        if (this.$refs.pr.isShowDropDown || (this.importerAll.length > 1 && this.$refs.im.isShowDropDown)) {
          setTimeout(() => {
            this.searchByHS(true)
          }, 150)
        } else {
          this.searchByHS()
        }
      } else {
        if (!this.$refs.ex || !this.$refs.im || !this.$refs.pr) return
        if (this.$refs.ex.isShowDropDown || this.$refs.im.isShowDropDown || this.$refs.pr.isShowDropDown) {
          setTimeout(() => {
            this.searchByOther(true)
          }, 150)
        } else {
          this.searchByOther()
        }
      }
    },
    jfNotice () {
      if (this.$i18n.locale === 'zh-CN') {
        this.GJFNotice(status => {
          if (status) {
            let jf = this.getApiValue()(this.$options.filters.getApiValueID(this.currentState))
            if (jf && jf.integral && jf.integral > 0) {
              this.GConfirm(`本次查询将消耗${jf.integral}积点，当天重复查询不再扣除积点。`, status => {
                if (status) {
                  this.searchHandleAfter()
                }
              })
            } else {
              this.searchHandleAfter()
            }
          } else {
            this.searchHandleAfter()
          }
        })
      } else {
        this.searchHandleAfter()
      }
    },
    searchHandleAfter () {
      if (!this.$refs.ex || !this.$refs.im || !this.$refs.pr) return

      if (this.currentState !== 'hscode') {
        this.$refs.ex && this.$refs.ex.setValueFromDefaultPlaceholder()
        this.$refs.im && this.$refs.im.setValueFromDefaultPlaceholder()
        if (!this.$refs.ex.text) {
          this.$Message.warning({content: this.$t('query.message.export_empty'), closable: true})
          return
        }
        if (!this.$refs.ex.value.id) {
          this.$Message.warning({content: this.$t('query.message.export_error'), closable: true})
          return
        }
        if (!this.$refs.im.text) {
          this.$Message.warning({content: this.$t('query.message.import_empty'), closable: true})
          return
        }
        if (!this.$refs.im.value.id) {
          this.$Message.warning({content: this.$t('query.message.import_error'), closable: true})
          return
        }
        if (this.$refs.ex.value.id === this.$refs.im.value.id) {
          this.$Message.warning({content: this.$t('query.message.notEqu'), closable: true})
          return
        }
      } else if (this.importerAll.length > 1) {
        if (!this.$refs.im) return
        this.$refs.im && this.$refs.im.setValueFromDefaultPlaceholder()
        if (!this.$refs.im.text) {
          this.$Message.warning({content: this.$t('query.message.import_empty'), closable: true})
          return
        }
        if (!this.$refs.im.value.id) {
          this.$Message.warning({content: this.$t('query.message.import_error'), closable: true})
          return
        }
      }
      this.$refs.pr && this.$refs.pr.setValueFromDefaultPlaceholder()
      if (this.$refs.pr && !this.$refs.pr.text) {
        this.$Message.warning({content: this.$t('query.message.product_empty'), closable: true})
        return
      }
      if (this.$refs.pr && !this.$refs.pr.value.id) {
        this.$Message.warning({content: this.$t('query.message.product_error'), closable: true})
        return
      }
      this.updateHistory({
        exporter: this.$refs.ex.value,
        importer: this.$refs.im.value,
        products: this.$refs.pr.value
      })
      switch (this.currentState) {
        case 'rate':
          this.$router.push({
            name: 'queryRateI',
            params: {
              exporter: this.$refs.ex.value.id,
              importer: this.$refs.im.value.id,
              hscode: this.$refs.pr.value.id
            }
          })
          break
        case 'rules':
          this.$router.push({
            name: 'queryRules',
            params: {
              exporter: this.$refs.ex.value.id,
              importer: this.$refs.im.value.id,
              hscode: this.$refs.pr.value.id
            }
          })
          break
        case 'hscode':
          this.$router.push({
            name: 'queryHsCode',
            params: this.importerAll.length > 1 ? {
              importer: this.$refs.im.value.id,
              hscode: this.$refs.pr.value.id
            } : {
              hscode: this.$refs.pr.value.id
            }
          })
          break
      }
    },
    tabChangeSetValue () {
      if (this.$refs.ex && this.$refs.im && this.$refs.pr) {
        if (this.$refs.ex && this.$refs.ex.value.id) {
          if (!this.$refs.ex.isShowInput) {
            this.$refs.ex.allowShowDropDown = false
          }
          this.$refs.ex.text = this._.trim(this.$refs.ex.value.text)
          this.$refs.ex.isShowInput = true
        } else {
          this.$refs.ex.isShowInput = false
        }
        if (this.$refs.im && this.$refs.im.value.id) {
          if (!this.$refs.im.isShowInput) {
            this.$refs.im.allowShowDropDown = false
          }
          this.$refs.im.text = this._.trim(this.$refs.im.value.text)
          this.$refs.im.isShowInput = true
        } else {
          this.$refs.im.isShowInput = false
        }
        if (this.$refs.pr && this.$refs.pr.value.id) {
          if (!this.$refs.pr.isShowInput) {
            this.$refs.pr.allowShowDropDown = false
          }
          this.$refs.pr.text = this._.trim(this.$refs.pr.value.id)
          this.$refs.pr.isShowInput = true
        } else {
          this.$refs.pr.isShowInput = false
        }
      }
    },
    selectQueryType (event, id, name) {
      this.currentState = id
    },
    handleClick (event, componentName) {
      switch (componentName) {
        case 'exporter':
          this.$refs.im.closeDowndown(false)
          this.$refs.pr.closeDowndown(false)
          break
        case 'importer':
          this.$refs.ex.closeDowndown(false)
          this.$refs.pr.closeDowndown(false)
          break
        case 'product':
          this.$refs.ex.closeDowndown(false)
          this.$refs.im.closeDowndown(false)
          break
      }
    },
    enterEvent (event, componentName) {
      switch (componentName) {
        case 'ex':
          if (this.$refs.ex.text) {
            this.setAutomatic(componentName)
          }
          break
        case 'im':
          if (this.$refs.im.text) {
            this.setAutomatic(componentName)
          }
          break
        case 'pr':
          if (this.$refs.pr.text) {
            this.setAutomatic(componentName)
          }
          break
      }
      setTimeout(() => {
        // if (this.$refs.ex.value.id && this.$refs.im.value.id && this.$refs.pr.value.id) {
        this.isShowSearchMsg = false
        this.searchHandle()
        // }
      }, 300)
    },
    escEvent (event) {
      if (event && event.keyCode === 27) {
        this.$refs.ex.closeDowndown(true)
        this.$refs.im.closeDowndown(true)
        this.$refs.pr.closeDowndown(true)
      }
    },
    tabEvent (event, componentName) {
      this.setAutomatic(componentName)
    },
    closeDropdown (event, componentName) {
      this.setAutomatic(componentName, false)
    },
    setAutomatic (componentName, isNextDropDown = true) {
      switch (componentName) {
        case 'ex':
          this.$refs.ex.closeDowndown(true)
          if (isNextDropDown || this.$refs.ex.text) {
            if (!this.$refs.im.text) {
              this.$refs.im.inputClick()
            } else if (!this.$refs.pr.text) {
              this.$refs.pr.inputClick()
            }
          }
          break
        case 'im':
          this.$refs.im.closeDowndown(true)
          if (isNextDropDown || this.$refs.im.text) {
            if (!this.$refs.pr.text) {
              this.$refs.pr.inputClick()
            }
          }
          break
        case 'pr':
          this.$refs.pr.closeDowndown(true)
          break
      }
    },
    ...mapSearchState({
      getActiveName: state => state.activeName
    }),
    ...mapSearchMutations([
      'updateState',
      'updateHistory'
    ]),
    ...mapDataGetters([
      'getApiValue',
      'getExporterById',
      'getImporterById'
    ])
  }
}
</script>

<style scoped>
  .quicksearch{
    position:fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10000;
    background-color: #fff;
    box-shadow: 0 3px 5px 0 rgba(207,207,207,0.50);
    padding: 12px 0;
    width: 100%;
    /*min-width: var(--pageMinWidth);*/
  }
  .wrap{
    width: 75%;
    margin: 0 auto;
    position: relative;
    padding-left: 100px;
    padding-right: 130px;
  }
  .quicksearch >>> .xdropdown{
    width: 100px;
    position: absolute;
    top:0;
    left: 0;
    height: 100%;
  }
  .quicksearch >>> .xdropdown .title{
    background-color: #F4FAFF;
    border: 1px solid #DBDBDB;
    border-right: 0 none;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    color: #1F8AFD;
    /*font-size: 11px;*/
    font-size: 13px;
    height: 100%;
  }
  .inputs{
    white-space: nowrap;
  }
  .ex, .im{
    width: 29%;
    float: left;
    border-right: 0 none !important;
  }
  .pr{
    width: 42%;
    float: left;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .im{
    border-radius: 0;
  }
  .btn{
    width: 120px;
    text-align: center;
    cursor:pointer;
    /* background-color: #0162e0;
    border-color: #0162e0; */
    background-color: #1F8AFD;
    transition: color .2s linear,background-color .2s linear,border .2s linear,box-shadow .2s linear;
    color: #fff;
    border-radius: 3px;
    position: absolute;
    top:0;
    right: 0;
    height: 100%;
  }
  .btn span{
    position: absolute;
    top:50%;
    left:50%;
    transform: translate(-50%, -50%);
    font-size: 1.4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/QuickSearch.vue